"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractStringElement = void 0;
class AbstractStringElement {
    constructor(nestingIndex, parsedString) {
        this.nestingIndex = nestingIndex;
        this.parsedString = parsedString;
    }
    setPrevious(previous) {
        this.previous = previous;
    }
    setNext(next) {
        this.next = next;
    }
    getPrevious() {
        return this.previous;
    }
    getNext() {
        return this.next;
    }
    getNestingIndex() {
        return this.nestingIndex;
    }
    getParsedString() {
        return this.parsedString;
    }
    incrementNestingIndex() {
        this.nestingIndex += 1;
    }
}
exports.AbstractStringElement = AbstractStringElement;
//# sourceMappingURL=AbstractStringElement.js.map